<template>
  <li class="nav-item">
    <a
      v-if="links.linkCliente1 !== null && links.linkCliente1 !== ''"
      :href="links.linkCliente1"
      target="_blank"
    >
      <i
        id="link-1"
        :class="getClassIcon(1)"
      />
      <b-tooltip
        target="link-1"
        triggers="hover"
        :title="links.tooltipIcone1"
        placement="top"
      />
    </a>
    <a
      v-if="links.linkCliente2 != null && links.linkCliente2 != ''"
      :href="links.linkCliente2"
      target="_blank"
    >
      <i
        id="link-2"
        :class="getClassIcon(2)"
      />
      <b-tooltip
        target="link-2"
        triggers="hover"
        :title="links.tooltipIcone2"
        placement="top"
      />
    </a>
  </li>
</template>

<script>
import { reactive, toRefs } from '@vue/composition-api'
import { createNamespacedHelpers } from 'vuex-composition-helpers'

export default {
  name: 'LinksCliente',
  
  beforeMount() {
    this.$store.dispatch('links/findAll')
  },
  
  setup() {
    const linkStore = createNamespacedHelpers('links')

    const state = reactive({
      links: linkStore.useGetters(['links']).links,
    })

    const getClassIcon = i => {
      if (state.links.iconeCliente1 == null || state.links.iconeCliente1 === '') {
        return 'fas fa-external-link-alt'
      }
      if (i === 1) {
        return `fas fa-${state.links.iconeCliente1}`
      }
      return `fas fa-${state.links.iconeCliente2}`
    }

    return {
      ...toRefs(state),
      getClassIcon,
    }
  },
}

</script>

<style scoped>
.nav-item a {
  padding: 0 0.5rem;
}
i.fas {
  font-size: 18px;
  margin-top: 3px;
}
</style>